// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { DialogTitleProps as MuiDialogTitleProps } from '@mui/material';
import { DialogTitle as MuiDialogTitle } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Flex from '@shared/components/Flex';

type Classes = Pick<MuiDialogTitleProps, 'classes'>;

export interface DialogTitleProps extends Classes, Omit<MuiDialogTitleProps, 'classes'> {
  className?: string;
  heading: React.ReactNode;
  onClose: () => any;
}

class DialogTitle extends React.Component<DialogTitleProps> {
  render() {
    const { heading, onClose, ...otherProps } = this.props;
    const classes = withStyles.getClasses(this.props);

    return (
      <MuiDialogTitle
        // disableTypography
        className={classes.root}
        {...otherProps}
      >
        <Flex
          alignItems="baseline"
          justifyContent="space-between"
        >
          <h1 className={classes.heading}>{heading}</h1>
          <IconButton
            disableRipple
            className={classes.closeIcon}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Flex>
      </MuiDialogTitle>
    );
  }
}

const DialogTitleStyled = withStyles(
  DialogTitle, 
  (theme, props) => ({
    "root": {
      padding: theme.spacing(6),
      backgroundColor: theme.palette.colors.greyLight5, 
    },
    "heading": {
      fontSize: 23,
      fontWeight: 500,
    },
    "closeIcon": {
      padding: 0,
    }
  })
);

export default DialogTitleStyled;